import axios from 'axios';
export interface NewTransactionData {
  tscName: string;
  tccId: number | undefined; // Por enquanto vamos fixar um valor, depois pode ser um select
  tscValue: number;
  tctId: 1 | 2; // 1 para Entrada, 2 para Saída
  usrId: number;
  tscRecurrence: 0 | 1;
  tscRecurrenceDate: string | null;
  usrIdTransaction: number | undefined; // ID do usuário
  tscMonth: number;
  tscYear: number;
  tscCheck: 0 | 1;
}

export interface Category {
  tccId: number;
  tccName: string;
  tctId: number;
}

export interface UpdateValue {
  tscId: number;
  tscValue: number;
}

export interface UserTransaction {
  usrId: number;
  usrName: string;
}

export interface CloseBalance {
  usrId: number;
  umbYear: number;
  umbMonth: number;
}

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3334/service/api/v1',
});

// const apiClient = axios.create({
//   baseURL: 'https://api-reactor-core-finances-production.up.railway.app/service/api/v1',
// });

// Interceptador para adicionar o token automaticamente nas requisições
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('@ReactorFinances:token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptador para lidar com respostas de erro (token expirado)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expirado ou inválido
      localStorage.removeItem('@ReactorFinances:token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const createTransaction = async (data: NewTransactionData) => {
  try {
    const response = await apiClient.post('/transaction/create', data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error('Erro de conexão ou inesperado.');
  }
};


export const getCategoriesByType = async (tctId: 1 | 2): Promise<Category[]> => {
  try {
    const response = await apiClient.get(`/transactioncategory/find/tctid/${tctId}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error('Erro de conexão ou inesperado.');
  }
};


export const getUserTransaction = async (): Promise<UserTransaction[]> => {
  try {
    const response = await apiClient.get(`/user/findfortransaction`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error('Erro de conexão ou inesperado.');
  }
};

export const getTransactionsByDate = async (month: number, year: number, userCurrent: string | undefined) => {
  try {
    const response = await apiClient.get(`/transaction/finddate/${month}/${year}`, {
      params: {
        usrId: userCurrent
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error(`Erro ao buscar transações para ${month}/${year}: ${error}`);
  }
};

export const getTransactionsBalance = async (tscYear: number, userCurrent: string | undefined) => {
  try {
    const response = await apiClient.get(`/transaction/findbalance/tscyear/${tscYear}`, {
      params: {
        usrId: userCurrent
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error(`Erro ao buscar transações: ${error}`);
  }
};


export const deleteTransaction = async (transactionId: number): Promise<void> => {
  try {
    await apiClient.delete(`/transaction/delete/${transactionId}`);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error('Erro de conexão ou inesperado.');
  }
};

export const updateTscCheckTransaction = async (tscId: number, tscCheck: number): Promise<void> => {
  try {
    await apiClient.put(`transaction/update/tsccheck/${tscId}/${tscCheck}`);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error('Erro de conexão ou inesperado.');
  }
};

export const updateValueTransaction = async (data: UpdateValue) => {
  try {
    const response = await apiClient.put('/transaction/update/value', data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error('Erro de conexão ou inesperado.');
  }
};

export const closeMonthBalance = async (data: CloseBalance) => {
  try {
    const response = await apiClient.post('/transaction/closemonthbalance', data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw error.response.data;
    }
    throw new Error('Erro de conexão ou inesperado.');
  }
};
